import { useCallback } from 'react'
import { useAppDispatch } from '@user/store/hooks'
import { getOpportunityNotes } from '@user/store/opportunityNotes/api'
import { ENTITY_TYPES } from '@sales-center/common'
import { getLeadNotes } from '@user/store/leadNotes/api'

export function useUpdateNoteList(entityId: number, entityType: ENTITY_TYPES) {
  const dispatch = useAppDispatch()

  const onUpdateNoteLIst = useCallback(() => {
    if (entityType === ENTITY_TYPES.Opportunity) {
      dispatch(
        getOpportunityNotes({
          opportunityId: entityId,
          includeExternal: true,
          query: { take: 3 },
        }),
      )
    }
    if (entityType === ENTITY_TYPES.Lead) {
      dispatch(
        getLeadNotes({
          leadId: entityId,
          includeExternal: true,
          query: { take: 3 },
        }),
      )
    }
  }, [entityId, dispatch, entityType])

  return {
    onUpdateNoteLIst,
  }
}
